// src/redux/kyp/Reducer.js
import { GET_KYP_DATA, GET_KYP_DATA_SUCCESS, GET_KYP_DATA_FAILED, DOWNLOAD_KYP_CSV, DOWNLOAD_KYP_CSV_SUCCESS, DOWNLOAD_KYP_CSV_FAILED, GET_AUTOMATED_KYP_LEADS, GET_AUTOMATED_KYP_LEADS_SUCCESS, GET_AUTOMATED_KYP_LEADS_FAILED, CLEAR_KYP_MESSAGE } from "./Action";

const initialState = {
  kypData: [],
  csvData: [],
  totalCount: 0,
  loading: false,
  downloading: false,
  message: ""
};

export default function kypReducer(state = initialState, action) {
  switch (action.type) {
    case GET_KYP_DATA:
      return { ...state, loading: true, message: "" };

    case GET_KYP_DATA_SUCCESS:
      return { ...state, loading: false, kypData: action.data || [], totalCount: action.data, message: "" };

    case GET_KYP_DATA_FAILED:
      return { ...state, loading: false, kypData: [], totalCount: 0, message: action.message || "Error fetching data" };

    case DOWNLOAD_KYP_CSV:
      return { ...state, downloading: true, message: "" };

    case DOWNLOAD_KYP_CSV_SUCCESS:
      return { ...state, downloading: false, csvData: action.data, message: action.message || "CSV downloaded successfully" };

    case DOWNLOAD_KYP_CSV_FAILED:
      return { ...state, downloading: false, csvData: [], message: action.message || "Failed to download CSV" };

    case CLEAR_KYP_MESSAGE:
      return {
        ...state,
        message: ""
      };
    case GET_AUTOMATED_KYP_LEADS:
      return { ...state, loading: true, message: "" };

    case GET_AUTOMATED_KYP_LEADS_SUCCESS:
      return { ...state, loading: false, kypData: action?.data || [], totalCount: action?.data, message: "" };

    case GET_AUTOMATED_KYP_LEADS_FAILED:
      return { ...state, loading: false, kypData: [], totalCount: 0, message: action.message || "Error fetching data" };

    default:
      return state;
  }
}
